// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_vc-0";
export var checkoutRateBadgeLink = "_vc-1";